import React from 'react';
import loader from './loader.gif';
import PropTypes from 'prop-types';

const ImageIsLoading = (props) => {
  const { imgAlt, imgWidth, imgHeight } = props?.loadingSettings;
  return (
    <img
      src={loader}
      width={imgWidth || '100%'}
      height={imgHeight || '100%'}
      alt={imgAlt || 'Cargando'}
    />
  );
};

ImageIsLoading.propTypes = {
  loadingSettings: PropTypes.shape({
    imgAlt: PropTypes.string,
    imgWidth: PropTypes.string,
    imgHeight: PropTypes.string,
  }),
};

export default ImageIsLoading;
